import { createSlice, current } from '@reduxjs/toolkit';
import {
	getCultivationUnitList,
	getCultivationUnit,
	addNewCultivationUnit,
	updateCultivationUnit,
	deleteCultivationUnit,
	checkCultivationUnitExists,
} from './thunk';

export const initialState = {
	itemCultivationUnitList: [],
	itemCultivationUnit: null,
	isCultivationUnitLoading: false,
	isCultivationUnitSuccess: false,
	dataCultivationUnit: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const CultivationUnitSlice = createSlice({
	name: 'CultivationUnit',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getCultivationUnitList.pending, state => {
			state.isLoadingList = true;
			state.isCultivationUnitSuccess = false;
		});

		builder.addCase(getCultivationUnitList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemCultivationUnitList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isCultivationUnitSuccess = true;
		});

		builder.addCase(getCultivationUnitList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isCultivationUnitSuccess = false;
		});

		builder.addCase(getCultivationUnit.pending, state => {
			state.isCultivationUnitLoading = true;
			state.isCultivationUnitSuccess = false;
		});

		builder.addCase(getCultivationUnit.fulfilled, (state, action) => {
			state.itemCultivationUnit = action.payload;
			state.isCultivationUnitLoading = false;
			state.isCultivationUnitSuccess = true;
		});

		builder.addCase(getCultivationUnit.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isCultivationUnitLoading = false;
			state.isCultivationUnitSuccess = false;
		});

		builder.addCase(addNewCultivationUnit.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewCultivationUnit.fulfilled, (state, action) => {
			state.itemCultivationUnitList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewCultivationUnit.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateCultivationUnit.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateCultivationUnit.fulfilled, (state, action) => {
			state.itemCultivationUnitList = state.itemCultivationUnitList.map(
				cultivationUnitList =>
					cultivationUnitList._id.toString() === action.payload._id.toString()
						? { ...cultivationUnitList, ...action.payload }
						: cultivationUnitList
			);
			state.statementList = state.statementList.map(cultivationUnitList =>
				cultivationUnitList._id.toString() === action.payload._id.toString()
					? { ...cultivationUnitList, ...action.payload }
					: cultivationUnitList
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
							item: action.payload,
							value: action.payload._id,
							label: action.payload.name,
					  }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateCultivationUnit.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteCultivationUnit.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteCultivationUnit.fulfilled, (state, action) => {
			state.itemCultivationUnitList = current(
				state.itemCultivationUnitList
			).filter(item => item._id !== action.payload._id);
			state.statementList = current(state.statementList).filter(
				item => item._id !== action.payload._id
			);
			state.statementListSelect = current(state.statementListSelect).filter(
				item => item.value !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteCultivationUnit.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkCultivationUnitExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkCultivationUnitExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkCultivationUnitExists.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = CultivationUnitSlice.actions;

export default CultivationUnitSlice.reducer;
